var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathStrategy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 37.517,
    viewBox: "0 0 44 37.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M42.429,26.262H40.857V22.51c0-3.1-2.115-5.628-4.714-5.628H23.571V11.255h1.571a1.744,1.744,0,0,0,1.571-1.876v-7.5A1.744,1.744,0,0,0,25.143,0H18.857a1.744,1.744,0,0,0-1.571,1.876v7.5a1.744,1.744,0,0,0,1.571,1.876h1.571v5.628H7.857c-2.6,0-4.714,2.524-4.714,5.628v3.752H1.571A1.744,1.744,0,0,0,0,28.138v7.5a1.744,1.744,0,0,0,1.571,1.876H7.857a1.744,1.744,0,0,0,1.571-1.876v-7.5a1.744,1.744,0,0,0-1.571-1.876H6.286V22.51a1.746,1.746,0,0,1,1.571-1.876H20.429v5.628H18.857a1.744,1.744,0,0,0-1.571,1.876v7.5a1.744,1.744,0,0,0,1.571,1.876h6.286a1.744,1.744,0,0,0,1.571-1.876v-7.5a1.744,1.744,0,0,0-1.571-1.876H23.571V20.635H36.143a1.746,1.746,0,0,1,1.571,1.876v3.752H36.143a1.744,1.744,0,0,0-1.571,1.876v7.5a1.744,1.744,0,0,0,1.571,1.876h6.286A1.744,1.744,0,0,0,44,35.642v-7.5A1.744,1.744,0,0,0,42.429,26.262Z",
    fill: "#499af8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathStrategy);
export default __webpack_public_path__ + "static/media/PathStrategy.4bc2e51e31cc608ba21849672b5f1fe7.svg";
export { ForwardRef as ReactComponent };